import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance } from 'vue';
import type { Exercise } from '@ilteducation/exercise-service-types';
import ImportButton from '@/components/buttons/ImportButton.vue';
import eventBus from '@/foundations/services/eventBus';
import { chunk, findExisting, parseRows, type ImportRow } from './import';

type Props = {
  title: string;
  resource: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {



const store = getCurrentInstance()!.proxy.$store;

const LOOKUP_CHUNK_SIZE = 50;

const fetchExisting = async (resourceIds: string[]): Promise<Exercise[]> => {
  const responses = await Promise.all(
    chunk([...new Set(resourceIds)], LOOKUP_CHUNK_SIZE).map((ids) =>
      store.dispatch('exercises/getList', { filter: { resourceId: ids }, pagination: { limit: 1000 } }),
    ),
  );
  return responses.flatMap((response: { data: Exercise[] }) => response.data ?? []);
};

const importExercises = async (entries: object[]) => {
  const { exercises, errors } = parseRows(entries as ImportRow[]);

  const existing = exercises.length ? await fetchExisting(exercises.map((e) => e.resourceId)) : [];

  const results = await Promise.allSettled(
    exercises.map((exercise) => {
      const match = findExisting(existing, exercise);
      return match
        ? store.dispatch('exercises/update', { id: match.id, data: exercise })
        : store.dispatch('exercises/create', { data: exercise });
    }),
  );

  const updated = results.filter((r, i) => r.status === 'fulfilled' && findExisting(existing, exercises[i])).length;
  const failed = results.filter((r) => r.status === 'rejected').length;
  const created = results.length - failed - updated;

  const summary = [`${created} created`, `${updated} updated`];
  if (failed) summary.push(`${failed} failed`);
  if (errors.length) summary.push(`${errors.length} skipped (row ${errors.map((e) => e.row).join(', ')})`);

  eventBus.$emit('snackbar.open', `Import done: ${summary.join(', ')}.`);
  if (failed || errors.length) {
    // eslint-disable-next-line no-console
    console.warn('Exercise import problems', {
      skipped: errors,
      failed: results.filter((r) => r.status === 'rejected'),
    });
  }
};

const fields = [
  { source: 'id', link: 'edit' },
  { source: 'title' },
  {
    source: 'type',
    sortable: true,
    label: 'Type',
  },
  {
    source: 'resourceId',
    type: 'reference',
    attributes: {
      reference: 'content',
      text: 'name',
    },
  },
  {
    source: 'resourceType',
    attributes: {
      chip: true,
      color: 'orange',
    },
  },
];

const filters = [
  {
    source: 'type',
    type: 'select',
    alwaysOn: true,
    attributes: {
      multiple: true,
    },
  },
  {
    source: 'resourceType',
    type: 'select',
    attributes: {
      multiple: true,
    },
  },
];

return { __sfc: true,store, LOOKUP_CHUNK_SIZE, fetchExisting, importExercises, fields, filters, ImportButton }
}

})